import * as React from "react";
import { useFormContext } from "react-hook-form";
import { DatePicker } from "components";
import { FormValues } from "../../duck";

const ExpirationDate: React.FC = () => {
  const { watch } = useFormContext<FormValues>();

  const startDate = watch("startDate");

  return (
    <DatePicker
      name="expirationDate"
      label="Expiration Date"
      minDate={startDate || undefined}
      futureYears={5}
      placeholderText="Expiration Date"
    />
  );
};

export default ExpirationDate;
